module.exports = __webpack_public_path__ + "static/img/noData.058fdb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/noData.png
// module id = nt0a
// module chunks = 1